import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, } from 'antd';
import moment from 'moment';
import { dataSeasonal, intervalData } from './data';
import imgSave from "../saveImg";
import Auth from "../Auth";
import TableText from "../TableText";
import "./index.scss";
import { calculation, getJson } from '@/method';
import FileSaver from "file-saver";
import { numConvert } from '../../../method';

const { MonthPicker } = DatePicker;


class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().format('D') <= 10 ?
                moment().subtract(2, 'month').format('YYYY-MM') :
                moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            note: { note: "" },
            loading: true,
            loadingSave: false,
            print: false,
            isUpdate: false,
            dataAll: {}
        }
    }


    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data, {
        es5_1_2 = [],
        banquet = {},
        outlets = {},
        Chinese = {},
        coffee = {},
        inter_banquet = {},
        inter_outlets = {},
        inter_Chinese = {},
        inter_coffee = {},
    }) => {
        // 区域平台数据
        data[1].area = calculation(coffee['cost'], coffee['REV'], 4).toFixed(3);
        data[0].area = calculation(coffee['REV'], outlets['REV'], 4).toFixed(3);
        data[3].area = calculation(Chinese['cost'], Chinese['REV'], 4).toFixed(3);
        data[2].area = calculation(Chinese['REV'], outlets['REV'], 4).toFixed(3);
        data[5].area = calculation(banquet['cost'], banquet['REV'], 4).toFixed(3);
        data[4].area = calculation(banquet['REV'], outlets['REV'], 4).toFixed(3);

        // 收入区间数据
        data[1].interval = calculation(inter_coffee['cost'], inter_coffee['REV'], 4).toFixed(3);
        data[0].interval = calculation(inter_coffee['REV'], inter_outlets['REV'], 4).toFixed(3);
        data[3].interval = calculation(inter_Chinese['cost'], inter_Chinese['REV'], 4).toFixed(3);
        data[2].interval = calculation(inter_Chinese['REV'], inter_outlets['REV'], 4).toFixed(3);
        data[5].interval = calculation(inter_banquet['cost'], inter_banquet['REV'], 4).toFixed(3);
        data[4].interval = calculation(inter_banquet['REV'], inter_outlets['REV'], 4).toFixed(3);

        // 本酒店数据
        data[1].hotel = numConvert(getJson([0, 'cost_percent'], es5_1_2)).toFixed(3);
        data[0].hotel = numConvert(getJson([0, 'revenue'], es5_1_2)).toFixed(3);
        data[3].hotel = numConvert(getJson([1, 'cost_percent'], es5_1_2)).toFixed(3);
        data[2].hotel = numConvert(getJson([1, 'revenue'], es5_1_2)).toFixed(3);
        data[5].hotel = numConvert(getJson([2, 'cost_percent'], es5_1_2)).toFixed(3);
        data[4].hotel = numConvert(getJson([2, 'revenue'], es5_1_2)).toFixed(3);

        console.log(data);
        this.setState({
            data,
        }, () => {
            this.onSave();
        });
    }

    onChangeUpdate = (data) => {
        this.setState({ isUpdate: data });
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data, this.state.dataAll);
    }

    // 获取表格5_6_1内容
    getData = (date) => {
        const dataBegin = JSON.stringify(dataSeasonal);
        let data = JSON.parse(dataBegin);
        fetch(`/performanceSeasonal?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data.length > 0) {
                data = x.data.data.sort((a, b) => a.sort - b.sort);
            }
            this.computeNum(data, x.data || {});
            this.setState({ loading: false, dataAll: x.data || {} });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }
    // 保存表格5-6-1内容
    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/performanceSeasonalAdd', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                this.setState({ isUpdate: true });
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    onExpoetExcel = () => {
        this.setState({ print: true, loading: true }, () => {
            const name = `Performance Analysis 酒店经营情况分析 YTD ${this.state.date}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table2').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table6_3', 1.5, '6.20', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    render() {
        const { data, print, date } = this.state;
        const seasonalMonth = ['3', '6', '9', '12'];
        const isDisplay = seasonalMonth.includes(moment(date).format('M'));

        const columns = [{
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'text', name: "name", onChange: this.onChange,
                };

                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Average Area Performance Data<br /> 区域平均数据 <br /> {getJson(['hotel', 'area'], this.state.dataAll, "")}</div>,
            dataIndex: 'area',
            key: 'area',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "area", onChange: this.onChange,
                    compared: {
                        title: ["Average Area Performance Data<br /> 区域平均数据"],
                        record,
                        sqlName: "performance_seasonal"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        },
        {
            title: <div>Revenue Range (RMB) <br /> 收入区间 （单位：元）<br />{intervalData[getJson(['hotel', 'income_interval'], this.state.dataAll, "")]}</div>,
            dataIndex: 'interval',
            key: 'interval',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "interval", onChange: this.onChange,
                    compared: {
                        title: ["Revenue Range (RMB) <br /> 收入区间 （单位：元）"],
                        record,
                        sqlName: "performance_seasonal"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        },
        {
            title: <div>Hotel Performance Data<br /> 本酒店数据</div>,
            dataIndex: 'hotel',
            key: 'hotel',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "hotel", onChange: this.onChange,
                    compared: {
                        title: ["Hotel Performance Data<br /> 本酒店数据"],
                        record,
                        sqlName: "performance_seasonal"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 style-center">
                    <Row className="title" id="table6_3"   >
                        <Row>1.1.3 Seasonal Cost % 季度累计</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={isDisplay ? data : []}
                            size="middle"
                            bordered
                            id="table2"
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_6_2">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={() => {
                                    this.setState({ print: true }, () => {
                                        this.onExpoetExcel();
                                    });
                                }}
                            >导出Excel</Button>
                            {/* <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button> */}
                        </Row>
                    </Auth>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/Seasonal.js